import React, { useState } from "react";
import { ProgressBar, CircularProgressBar } from "../../../../../components";

const progressProps = [
  { fillColor: "bg-primary-800", height: "h-1", value: 20 },
  { fillColor: "bg-success-800", height: "h-2", value: 40 },
  { fillColor: "bg-info-800", height: "h-3", value: 60 },
  { fillColor: "bg-leave-800", height: "h-4", value: 80 },
  { fillColor: "bg-draft-800", height: "h-5", value: 100 },
  { fillColor: "bg-primary", height: "h-1", value: 20 },
  { fillColor: "bg-success", height: "h-2", value: 40 },
  { fillColor: "bg-info", height: "h-3", value: 60 },
  { fillColor: "bg-leave", height: "h-4", value: 80 },
  { fillColor: "bg-draft", height: "h-5", value: 100 },
  { fillColor: "bg-primary-200", height: "h-1", value: 20 },
  { fillColor: "bg-success-200", height: "h-2", value: 40 },
  { fillColor: "bg-info-200", height: "h-3", value: 60 },
  { fillColor: "bg-leave-200", height: "h-4", value: 80 },
  { fillColor: "bg-draft-200", height: "h-5", value: 100 },
];
const sampleData1 = [
  { name: "Completed", value: 45, color: "success", colorDepth: 500 }, // Takes ~53% of circle (45/85)
  { name: "In Progress", value: 25, color: "primary", colorDepth: 600 }, // Takes ~29% of circle (25/85)
  { name: "Pending", value: 15, color: "info", colorDepth: 400 },
  { name: "Not Started", value: 15, color: "warning", colorDepth: 400 },
];

const ProgressBarList = () => {
  const maxValue = 100;

  return (
    <div className="py-5 flex flex-col">
      <h6>Progress Bar</h6>
      <div className="grid grid-cols-5 gap-5">
        {progressProps.map((data) => (
          <div className="py-7">
            <ProgressBar
              value={data.value}
              maxValue={maxValue}
              fillColor={data.fillColor}
              height={data.height}
            />
          </div>
        ))}
      </div>

      <h6>Circular Progress Bar</h6>
      <div className="flex justify-start items-center gap-10 mt-5">
        <CircularProgressBar value={75} />
        <CircularProgressBar value={90} variant="fulldonut" />
        <CircularProgressBar
          variant="fulldonut"
          size={220}
          strokeWidth={20}
          data={[
            { name: "Completed", value: 20, color: "primary", colorDepth: 500 },
            {
              name: "In Progress",
              value: 40,
              color: "success",
              colorDepth: 500,
            },
          ]}
        />
        <CircularProgressBar
          variant="fulldonut"
          size={220}
          strokeWidth={20}
          data={sampleData1}
        />
        <CircularProgressBar
          variant="halfdonut"
          size={240}
          strokeWidth={18}
          data={[
            { name: "Name1", value: 30, color: "warning" },
            { name: "Name2", value: 70, color: "danger" },
          ]}
        />
      </div>
    </div>
  );
};

export default ProgressBarList;
